<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{'addons.banners.editSuccess' | translate}}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form">
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.banners.image' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <app-image-uploader
            wrongTypeMessage="{{'addons.banners.wrongType' | translate}}"
            description="{{'addons.banners.description' | translate}}"
            additionalDescription="{{'addons.banners.additionalDescription' | translate}}"
            [previewUrl]="previewUrl"
            (onFileChange)="fileChange($event)"
            (onFileRemove)="removeFile()"
          ></app-image-uploader>
          <input matInput formControlName="file" hidden="true">
          <mat-error *ngIf="form.hasError('required', ['file'])">{{'fileRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.banners.dimensions' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="imageWidth" type="number" min="0" [placeholder]="'addons.banners.widthPlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <span matSuffix>px</span>
          <mat-error *ngIf="form.hasError('min', ['imageWidth'])">{{'addons.banners.minWidth' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.banners.name' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="name" type="text" [placeholder]="'addons.banners.namePlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['name'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.banners.url' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="url" type="text" [placeholder]="'addons.banners.urlPlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['url'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.banners.utm' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="utm" type="text" [placeholder]="'addons.banners.utmPlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['utm'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="saving">
      <mat-spinner *ngIf="saving" diameter="20" class="dc-btn-spinner"></mat-spinner>
      {{ saving ? ('saving' | translate) : ('save' | translate) }}
    </button>
  </footer>
</div>
